export default __webpack_public_path__ + "static/media/map (2).aedf5c46.webp";